import apiServices from "../apiServices";
import { validateOrThrowApiResponse } from "../response-validator";

type CreateNotePayload = {
    name: string;
    detail?: string;
    teacher_uuid?: string;
    id_gameinfo?: number | string;
    id_sequenceinfo?: number | string;
};

type UpdateNotePayload = {
    name?: string;
    detail?: string;
    teacher_uuid?: string;
    id_gameinfo?: number | string;
    id_sequenceinfo?: number | string;
};

const noteAPI = {

    create(payload: CreateNotePayload) {
        return apiServices
            .post(`/api/note`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error create note:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    update(id: number | string, payload: UpdateNotePayload) {
        return apiServices
            .put(`/api/note/${id}`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error update note:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    getAll() {
        return apiServices
            .get(`/api/note`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getAll note:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    getById(id: number | string) {
        return apiServices
            .get(`/api/note/${id}`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getById note:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    getByGameUuidOrSequenceUuidOrUuidNewGen(uuid: string) {
        return apiServices
            .get(`/api/note/uuid/${uuid}`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getByGameUuidOrSequenceUuidOrUuidNewGen note:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    softDelete(id: number | string) {
        return apiServices
            .patch(
                `/api/note/${id}/soft-delete`,
                {},
                {
                    headers: {
                        Accept: "application/json",
                    },
                }
            )
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error softDelete note:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    }

}

export default noteAPI;